<span *ngIf="test">
  <div class="row ">
    <div class="col-3 offset-9">
      <circle-progress class="text-right"
        [percent]='perTimeLeft'
        [maxPercent]='timeMax'
        [radius]="35"
        [outerStrokeWidth]="10"
        [innerStrokeWidth]="0"
        [outerStrokeColor]="'#78C000'"
        [innerStrokeColor]="'#C7E596'"
        [animation]="true"
        [animationDuration]="300"
        [renderOnClick]="false"
        [showSubtitle]="true"
        [subtitle]='subTitle'
      ></circle-progress>
    </div>
  </div>
  
  <div class="row unselectable">
    <div class="col-12">
      <div class="card mt-3">
        <div class="card-header bg-dark text-white">
          Question : {{currTest+1}}
        </div>
        <div class="card-body">
          <h6 class="card-title">{{test.results[currTest].category}}</h6>
          <p class="card-text">{{test.results[currTest].question | safeHtml}}</p>
        </div>
        <ul class="list-group list-group-flush">
          <button type="button" (click)="validateAnswer($event.target.outerText)"
            class="list-group-item btn btn-light btn-block btn-warp">{{test.results[currTest].incorrect_answers[0] | safeHtml}}</button>
          <button type="button" (click)="validateAnswer($event.target.outerText)"
            class="list-group-item btn btn-light btn-block btn-warp">{{test.results[currTest].incorrect_answers[1] | safeHtml}}</button>
          <button type="button" *ngIf="test.results[currTest].type==='multiple'"
            (click)="validateAnswer($event.target.outerText)"
            class="list-group-item btn btn-light btn-block btn-warp">{{test.results[currTest].incorrect_answers[2] | safeHtml}}</button>
          <button type="button" *ngIf='test.results[currTest].type==="multiple"'
            (click)="validateAnswer($event.target.outerText)"
            class="list-group-item btn btn-light btn-block btn-warp">{{test.results[currTest].incorrect_answers[3] | safeHtml}}</button>
        </ul>
      </div>
    </div>
  </div>
</span>